import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IAcademicGroupMember } from "./routeType";

const { key, getPath } = getApi("academicGroups.member.post");

type IExtractedRouteType =
  IAcademicGroupMember["academicGroupMemberProfileSingleCreate"];

export type IPostAcademicGroupMembers = IPickMutation<IExtractedRouteType>;

const postAcademicGroupMembers: Fetcher<
  IPostAcademicGroupMembers["response"],
  IPostAcademicGroupMembers["variables"]
> = ({ academicGroupId, ...params }) => {
  return axiosClient.get(getPath({ academicGroupId }), { params });
};

export const usePostAcademicGroupMembers = createQuery({
  queryKey: [key],
  fetcher: postAcademicGroupMembers,
});
